/**
 * Decide when an event mutation should call the `*-with-sync` companion endpoint
 * vs the legacy variant (mirrors `incidentSyncPolicy.ts`).
 *
 * Per the Event ↔ Kanban integration (guide §1.5 / backend doc §6.2): legacy
 * `/events/*` handlers never propagate — propagation only runs through the
 * `*-with-sync` companions. The frontend rule: route through `with-sync` only
 * when at least one bridge link for the event has at least one `sync_*` flag on.
 * Calling `with-sync` with no flags on is harmless server-side but adds latency
 * and noise; we avoid it for clarity.
 */

import type { EventKanbanLink } from '../types/eventTeam';

export function anyEventSyncFlagOn(link: EventKanbanLink): boolean {
  return (
    link.sync_status === 1 ||
    link.sync_priority === 1 ||
    link.sync_due_date === 1 ||
    link.sync_assignees === 1 ||
    link.sync_comments === 1 ||
    link.propagate_watchers === 1
  );
}

/**
 * @returns `true` when at least one bridge link for the event has at least one
 *          sync flag set. `null`/`undefined`/empty → `false` (no propagation possible).
 */
export function shouldUseSyncForEvent(links: EventKanbanLink[] | null | undefined): boolean {
  if (!links || links.length === 0) return false;
  return links.some(anyEventSyncFlagOn);
}
